import { useNavigate } from "react-router-dom";
import {
  Calendar,
  Heart,
  Plus,
  ChevronRight,
  Sparkles,
  Package,
  Barcode
} from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export const MobileHome = ({ user }) => {
  const navigate = useNavigate();

  const quickActions = [
    {
      id: "quick-event",
      title: "Quick Add Event",
      description: "Log an event or activity",
      icon: Calendar,
      color: "from-[#4B8BC7] to-[#3A8D6E]",
      bgColor: "bg-blue-50",
      iconColor: "brand-blue",
      path: "/mobile/events",
      action: "add"
    },
    {
      id: "inventory",
      title: "Inventory",
      description: "Scan QR codes, manage supplies",
      icon: Package,
      color: "from-[#3A8D6E] to-[#6B4E8D]",
      bgColor: "bg-green-50",
      iconColor: "brand-green",
      path: "/mobile/inventory"
    },
    {
      id: "offline-checkout",
      title: "Offline Checkout",
      description: "Scan member & book barcodes",
      icon: Barcode,
      color: "from-[#4B8BC7] to-[#6B4E8D]",
      bgColor: "bg-indigo-50",
      iconColor: "brand-purple",
      path: "/mobile/offline-checkout"
    },
    {
      id: "shout-outs",
      title: "Shout Outs",
      description: "Thank a colleague",
      icon: Heart,
      color: "from-[#C4453A] to-[#E67B44]",
      bgColor: "bg-red-50",
      iconColor: "brand-red",
      path: "/mobile/shout-outs"
    }
  ];

  return (
    <div className="px-4 py-6" data-testid="mobile-home">
      {/* Welcome Message */}
      <div className="mb-8">
        <h2 className="text-2xl font-heading font-semibold text-stone-800">
          Hi, {user?.name?.split(" ")[0] || "there"}!
        </h2>
        <p className="text-muted-foreground mt-1">
          What would you like to do?
        </p>
      </div>

      {/* Quick Action Cards */}
      <div className="space-y-4">
        {quickActions.map((action) => {
          const Icon = action.icon;
          return (
            <Card
              key={action.id}
              className="overflow-hidden border-0 shadow-md hover:shadow-lg transition-all duration-300 cursor-pointer active:scale-[0.98]"
              onClick={() => navigate(action.path, { state: { action: action.action } })}
              data-testid={`mobile-card-${action.id}`}
            >
              <div className={`h-1.5 bg-gradient-to-r ${action.color}`} />
              <CardContent className="p-5">
                <div className="flex items-center gap-4">
                  <div className={`w-14 h-14 rounded-2xl ${action.bgColor} flex items-center justify-center flex-shrink-0`}>
                    <Icon className={`h-7 w-7 ${action.iconColor}`} strokeWidth={1.5} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-lg text-stone-800">
                      {action.title}
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      {action.description}
                    </p>
                  </div>
                  <ChevronRight className="h-5 w-5 text-stone-400 flex-shrink-0" />
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Today's Tip */}
      <div className="mt-8 p-4 bg-gradient-to-br from-[#E5A94B]/20 to-[#E67B44]/20 rounded-2xl border border-[#E5A94B]/30">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-xl bg-[#E5A94B]/30 flex items-center justify-center flex-shrink-0">
            <Sparkles className="h-5 w-5 brand-gold" />
          </div>
          <div>
            <p className="font-medium text-stone-800 text-sm">Quick Tip</p>
            <p className="text-stone-600 text-sm mt-0.5">
              Use "Quick Add Event" to quickly log activities with just a title, date, and optional photo!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
